export default __webpack_public_path__ + "static/media/scan-1.befbbe7a.jpeg";